import AboutSection from "../../Components/HomeSections/AboutSection";
import HeroSection from "../../Components/HomeSections/HeroSection";
import PracticeAreas from "../../Components/HomeSections/Practices";
import TestimonialSlider from "../../Components/HomeSections/Testimonials";
import WhyChooseUs from "../../Components/HomeSections/WhyChooseUs";
import ContactForm from "../../Components/HomeSections/ContactForm";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import ServicesList from "../../Components/Services/ServicesList";
// import { Helmet } from "react-helmet";

const HomePage =()=>{
    return(
        <>

        <Header/>
        <HeroSection/>
        <AboutSection/>
        <PracticeAreas/>
        <WhyChooseUs/>
        <TestimonialSlider/>
        <ContactForm/>
        <ServicesList/>
        <Footer/>
        </>
    )
}

export default HomePage;